const CourseReducers = (currentState = { loading: true }, action) => {
  switch (action.type) {
    case 'SET_COURSE':
      return {
        ...currentState,
        language: action.language,
        actor: action.actor,
        availableCourseLanguages: action.availableCourseLanguages,
        courseId: action.course,
        stepId: action.stepId,
        currentLoc: action.currentLoc,
        dataUrlBase: action.dataUrlBase,
        learningPathJson: action.learningPathJson,
        courseTitle: action.courseTitle,
        currentStep: action.currentStep,
        nextStep: action.nextStep,
        previousStep: action.previousStep,
        flatpath: action.flattentedTree,
        currentModule: action.currentModule,
        currentBlock: action.currentBlock,
        loading: false
      };
    case 'STEP_CHANGE':
      return {
        ...currentState,
        stepId: action.stepId,
        dataUrlBase: action.dataUrlBase,
        currentLoc: action.currentLoc,
        learningPathJson: action.learningPathJson,
        courseTitle: action.courseTitle,
        currentStep: action.currentStep,
        nextStep: action.nextStep,
        previousStep: action.previousStep,
        flatpath: action.flattentedTree,
        currentModule: action.currentModule,
        currentBlock: action.currentBlock,
        loading: false
      };
    case 'COMMON_ASSETS':
      return {
        ...currentState,
        commonAssets: action.commonAssets
      };
    case 'PATH_NOT_FOUND':
      return {
        ...currentState,
        learningPathNotFound: true
      };
    case 'RESET_COURSE':
      return {
        loading: true
      };
    default:
      return currentState;
  }
};
export default CourseReducers;
